<!--
 * @Description:详情，编辑底部按钮  集成取消，重置功能
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-06-09 10:59:22
 * @LastEditors: cxh
 permission={
    save:'' // 新增、编辑保存
    edit:'' // 跳转编辑控制
 }
-->
<template>
  <dc-layout-footer>
    <dc-layout-button-group>
      <a-button @click="goBack()" :loading="loading">{{ t('btn.cancel') }}</a-button>
      <a-button @click="handleReset()" v-if="!props.disabled" :loading="loading">{{ t('btn.reset') }}</a-button>
      <slot>
        <template v-if="!hideOk">
          <template v-if="props.disabled">
            <SellerButton
              type="primary"
              :workCode="workCode"
              controlType="none"
              @click="goUpdate()"
              :loading="loading"
              v-permission="permissionPage?.edit"
              >{{ okTextComputed }}</SellerButton
            >
          </template>
          <template v-else>
            <a-button type="primary" @click="onSubmit()" :loading="loading" v-permission="permissionPage?.save">{{
              okTextComputed
            }}</a-button>
          </template>
          <a-button v-if="againBtn" type="primary" @click="onSubmit()" :loading="loading" v-permission="permissionPage?.save"
            >保存并新建</a-button
          >
        </template>
      </slot>
    </dc-layout-button-group>
  </dc-layout-footer>
</template>
<script lang="ts">
import { ref, computed } from 'vue'
import cosFooterButtonProps from '../cosFooterButton'
import { useRouter } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import { layoutTags } from '@dc-platform/dc-interaction'
import { useI18n } from 'vue-i18n'

export default { name: 'CosFooterButton' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const props = defineProps(cosFooterButtonProps())
const router = useRouter()
const emit = defineEmits(['change', 'update:value', 'submit', 'goUpdate', 'goBack', 'reset', 'validate'])
const handleBtn = ref(false)
const okTextComputed = computed(() => {
  if (props.okText) {
    return props.okText
  }
  if (props.disabled) {
    return t('btn.edit')
  }
  return t('btn.save')
})
const goBack = () => {
  if (location.hostname === 'localhost') {
    router.go(-1)
  } else {
    layoutTags.close()
  }
}
const goUpdate = () => {
  if (props.editUrl) {
    router.push(props.editUrl)
  }
  emit('goUpdate')
}
const handleReset = () => {
  const result: any = {
    ...cloneDeep(props.resetValue)
  }
  if (Array.isArray(props.value)) {
    emit('update:value', result)
    emit('reset', result)
  } else {
    for (const key in props.value) {
      if (result[key] === undefined) {
        result[key] = undefined
      }
    }
    emit('update:value', Object.assign(props.value, result))
    emit('reset', Object.assign(props.value, result))
  }
  setTimeout(() => {
    props.formRef?.clearValidate()
  })
}
const onSubmit = () => {
  handleBtn.value = true
  if (props.formRef) {
    props.formRef
      .validate()
      .then(async () => {
        emit('submit')
      })
      .catch((err: any) => {
        const { errorFields } = err
        props.formRef?.scrollToField(errorFields[0].name, {
          scrollMode: 'if-needed',
          block: 'center',
          inline: 'end'
        })
      })
  } else {
    emit('submit')
  }
  emit('validate')
}
defineExpose({
  handleReset
})
</script>
